import { render } from "./TourGuide.vue?vue&type=template&id=5d264355&scoped=true"
import script from "./TourGuide.vue?vue&type=script&lang=js"
export * from "./TourGuide.vue?vue&type=script&lang=js"

import "./TourGuide.vue?vue&type=style&index=0&id=5d264355&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5d264355"

export default script